export const FETCH_TRAILS_START = 'FETCH_TRAILS_START';
export const FETCH_TRAILS_SUCCESS = 'FETCH_TRAILS_SUCCESS';
export const FETCH_TRAILS_ERROR = 'FETCH_TRAILS_ERROR';

export const SELECT_TRAIL = 'SELECT_TRAIL';
export const DESELECT_TRAIL = 'DESELECT_TRAIL';
export const RESET_SELECTED_TRAILS = 'RESET_SELECTED_TRAILS';
